import type { IVariable } from "@bbj-types/utils";
import { InputAdornment, List, ListItemButton, TextField, type TextFieldProps } from "@mui/material";
import type { ChangeEvent } from "react";
import { useVariablesTextField } from "./logics";
import { VariableIcon } from "./variableIcon";

export type TVariableTextFieldProps = {
  disabled: boolean;
  value: string | undefined;
  onChange: (value: string) => void;
  variableList: IVariable[];
  label?: string;
} & Omit<TextFieldProps, "onChange">;

export const VariableTextField = ({
  disabled,
  value,
  onChange,
  variableList,
  label,
  ...props
}: TVariableTextFieldProps) => {
  const { setCursorPosition, handleAddVariableInField } = useVariablesTextField(onChange);
  return (
    <>
      <TextField
        {...props}
        size="small"
        label={label ?? "Objet *"}
        disabled={disabled}
        value={value ?? ""}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        onKeyDown={(e) => {
          const target = e.target as HTMLInputElement;
          if (target.selectionEnd) {
            setCursorPosition(target.selectionEnd);
          }
        }}
        onSelect={(e: ChangeEvent<HTMLInputElement>) => {
          if (e.target.selectionEnd) {
            setCursorPosition(e.target.selectionEnd);
          }
        }}
        slotProps={{
          input: {
            endAdornment: variableList.length > 0 && (
              <TextField
                select
                disabled={disabled}
                variant="standard"
                size="small"
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="end">
                        <VariableIcon />
                      </InputAdornment>
                    ),
                    disableUnderline: true,
                  },

                  select: {
                    onClose: () => {
                      setTimeout(() => {
                        (document.activeElement as HTMLElement).blur();
                      }, 0);
                    },
                  }
                }}>
                <List>
                  {variableList.map((variable) => (
                    <ListItemButton
                      key={variable.value}
                      onClick={() => {
                        handleAddVariableInField(value, variable);
                      }}
                    >
                      {variable.label}
                    </ListItemButton>
                  ))}
                </List>
              </TextField>
            ),
          }
        }}
      />
    </>
  );
};
